var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 32,
  viewBox: "0 0 35 32",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M25 0c5.523 0 10 4.408 10 9.846 0 6.199-3.763 11.255-10.657 17.043l-.402.335Q18.501 32 17.5 32t-6.441-4.776C3.909 21.295 0 16.164 0 9.846 0 4.408 4.477 0 10 0c2.902 0 5.515 1.217 7.342 3.16l.157.173.16-.172A10.04 10.04 0 0 1 24.72.004z"
})));
export default SvgTiktokMobileHeart;